import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {NestedTreeControl} from '@angular/cdk/tree';
import {MatTreeNestedDataSource} from '@angular/material/tree';
import { AutenticacionService } from '../generico/servicio/autenticacion.service';
import { MenuNode } from '../_models/menu';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit{

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

    treeControl = new NestedTreeControl<MenuNode>(node => node.child);
    dataSource = new MatTreeNestedDataSource<MenuNode>();
    view_menu = false;

    constructor(private breakpointObserver: BreakpointObserver,
      private auth : AutenticacionService) {
      }

    ngOnInit(): void {
      if (this.auth.currentUserValue){
        this.dataSource.data = this.auth.currentUserValue.menu;
        this.view_menu = true
      }
    }
    
    hasChild = (_: number, node: MenuNode) => !!node.child && node.child.length > 0;
  
}
